import { render, staticRenderFns } from "./PositiveInfectionsLineChart.vue?vue&type=template&id=20968c7e&"
import script from "./PositiveInfectionsLineChart.vue?vue&type=script&lang=js&"
export * from "./PositiveInfectionsLineChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports